import { render, staticRenderFns } from "./document.vue?vue&type=template&id=dd67e0d6&scoped=true&"
import script from "./document.vue?vue&type=script&lang=js&"
export * from "./document.vue?vue&type=script&lang=js&"
import style0 from "./document.vue?vue&type=style&index=0&id=dd67e0d6&prod&lang=css&"
import style1 from "./document.vue?vue&type=style&index=1&id=dd67e0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67e0d6",
  null
  
)

export default component.exports